export default {
  title: 'Disponibilidade dos Locais',
  list: 'Lista',
  kanban: 'Kanban',

  place: 'Local',
  status: 'Status',
  'status.available': 'Disponível',
  'status.unavailable': 'Indisponível',

  origin: 'Origem da última mudança',
  'origin.non_compliance': 'Não conformidade',
  'origin.automation': 'Automação',
  'origin.manual': 'Manual',

  changedAt: 'Data da última alteração',
  responsible: 'Responsável',
  openNonCompliances: 'Não conformidades abertas',
  noResponsible: 'Automático',
  neverChanged: 'Nunca alterado',

  changeStatusManually: 'Alterar status manualmente',
  changeStatusTo: 'Alterar status do local para',
  reason: 'Motivo (opcional)',
  reasonPlaceholder: 'Descreva o motivo da alteração',
  confirmChangeStatus: 'Tem certeza que deseja alterar o status de disponibilidade deste local?',
  changeStatusSuccess: 'Status de disponibilidade alterado com sucesso.',
  changeStatusError: 'Ocorreu um erro ao alterar o status de disponibilidade.',

  filterByStatus: 'Status de disponibilidade',
  filterByOrigin: 'Origem da última mudança',

  moreOptions: 'Mais opções',
  automations: 'Automações',

  'statusSourceConfig.buttonLabel': 'Configurações',
  'statusSourceConfig.title': 'Origem do Status de Disponibilidade',
  'statusSourceConfig.description':
    'Selecione de onde o status de disponibilidade dos locais pode ser atualizado automaticamente.',
  'statusSourceConfig.nonCompliance': 'Não Conformidade',
  'statusSourceConfig.automation': 'Automação',

  'tabs.details': 'Detalhes',
  'tabs.history': 'Histórico',

  'history.empty': 'Ainda não há histórico de mudanças de status para este local.',
  'history.lastChange': 'Última mudança de status',
  'history.changedTo': 'Status alterado para {{status}}',

  'openNonCompliancesList.title': 'Não conformidades abertas',
  'openNonCompliancesList.empty': 'Este local não possui não conformidades abertas.',

  'modals.changeAvailabilityStatus': 'Alterar status de disponibilidade',
  'modals.availabilityDetails': 'Disponibilidade do local'
}
